<div class="container">
  <div
    *ngIf="product$ | async as product"
    gdAreas="name name name name | images images categories cart | store store store empty | detail detail detail empty "
    gdAreas.lt-md="name | images | store | categories | cart | detail "
    gdGap="16px"
    gdRows="auto auto auto auto"
    gdColumns.gt-sm="200px 200px 345px 280px"
    gdColumns.sm="repeat(auto-fill, minmax(300px, 1fr))"
    gdColumns.xs="repeat(auto-fill, minmax(300px, 1fr))"
    gdRows.lt-md="auto auto auto auto auto"
  >
    <div gdArea="name">
      <h1>{{ product.name }}</h1>
    </div>
    <div gdArea="images">
      <mat-card class="image-card max-width">
        <div
          *ngFor="
            let image of productImages
              | paginate
                : {
                    id: 'new',
                    itemsPerPage: 1,
                    currentPage: pageNumber,
                    totalItems: productImages.length
                  }
          "
          class="controls max-width"
        >
          <img
            crossorigin="anonymous"
            [ngSrc]="image"
            alt="image du produit"
            width="600"
            height="300"
            class="max-width"
            mat-card-image
            priority
          />
        </div>
        <br />
        <pagination-template
          #newPaginator="paginationApi"
          (pageChange)="pageNumber = $event"
          [id]="'new'"
          class="controls"
        >
          <div
            class="controls"
            fxLayout="row"
            fxLayoutAlign="space-evenly center"
          >
            <button
              (click)="newPaginator.previous()"
              [disabled]="newPaginator.isFirstPage()"
              color="primary"
              mat-icon-button
              aria-label="précédent"
            >
              <mat-icon>arrow_back_ios</mat-icon>
            </button>
            <button
              (click)="newPaginator.next()"
              [disabled]="newPaginator.isLastPage()"
              color="primary"
              mat-icon-button
              aria-label="suivant"
            >
              <mat-icon>arrow_forward_ios</mat-icon>
            </button>
          </div>
        </pagination-template>
      </mat-card>
    </div>
    <div gdArea="categories"><app-product-details-categories [product]="product"></app-product-details-categories></div>
    <div gdArea="cart">
      <mat-card>
        <div fxLayout="column" fxLayoutAlign="space-between center">
          <h2 *ngIf="product?.price !== 0; else free">
            {{ product?.price! | price | currency }}
          </h2>
          <ng-template #free>
            <h2>Gratuit</h2>
          </ng-template>
          <button
            (click)="addToCart(product, counter)"
            color="primary"
            mat-raised-button
          >
            Ajouter au panier
          </button>
        </div>
      </mat-card>
    </div>
    <div gdArea="store">
      <app-store-preview [storeID]="product.store!"></app-store-preview>
    </div>
    <div gdArea="detail">
      <mat-card>
        <mat-tab-group [selectedIndex]="0" [preserveContent]="true" dynamicHeight>
          <mat-tab label="Description">
            <div class="container">
              <p [innerText]="product.description"></p>
            </div>
          </mat-tab>
        </mat-tab-group>
      </mat-card>
    </div>
    <div gdArea="empty"></div>
  </div>
</div>
